import React from "react"
import {useTranslation} from "react-i18next";
import {Stack, Typography} from "@mui/material";
import {ServiceCardType} from "../Types";

interface PaymentHeadersProps {
    serviceCard: ServiceCardType
}

const PaymentHeaders = ({serviceCard}: PaymentHeadersProps) => {
    const { t } = useTranslation()

    return (<Stack direction="column" spacing={4} alignItems="center">
        <Typography variant="h3">{t('selfService.paymentEvent')}</Typography>
    </Stack>)
}

export default PaymentHeaders
